import { render } from "./WorkspaceSelection.vue?vue&type=template&id=2bcac9f2"
import script from "./WorkspaceSelection.vue?vue&type=script&lang=js"
export * from "./WorkspaceSelection.vue?vue&type=script&lang=js"

import "./WorkspaceSelection.vue?vue&type=style&index=0&id=2bcac9f2&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__